/*
 * Integrating the server validation errors into React Hook Form fields
 *
 * Ref: https://www.carlrippon.com/react-hook-form-server-validation/
 */
import { FieldValues, UseFormSetError, Path } from 'react-hook-form';

const setServerErrors = <T extends FieldValues>(
  errors: { [P in keyof T]?: string[] | string | null },
  setError: UseFormSetError<T>
) => {
  Object.keys(errors).forEach(key => {
    const errorMessages = errors[key as keyof T];
    if (Array.isArray(errorMessages)) {
      setError(key as Path<T>, {
        type: 'server',
        message: errorMessages.join(', '),
      });
    } else if (typeof errorMessages === 'string') {
      setError(key as Path<T>, {
        type: 'server',
        message: errorMessages,
      });
    } else {
      // Fallback message
      setError(key as Path<T>, {
        type: 'server',
        message: 'An unexpected error occurred',
      });
    }
  });
};

export default setServerErrors;
